import { StaticPageUrls } from '../../../api/analytics/ClientEvents';
import { Backend } from '../../../api/Backend';
import { ChannelModel } from '../../../api/EpgApi.types';
import { EpgGuideChannelDataSource } from './EpgGuideChannelDataSource';

const _constants = {
  firstLoadAmount: 10,
  loadAmount: 3,
};

export class EpgGuideDataSource {
  private initialized = false;
  private allChannels: ChannelModel[] = [];
  private validChannels: ChannelModel[] = [];
  private channelDatasources: EpgGuideChannelDataSource[] = [];
  private backend: Backend;
  private loadedIdx = 0;
  private initPromise: Promise<any> | undefined;

  constructor(backend: Backend) {
    this.backend = backend;
  }

  /**
   * Load valid channels
   */
  _initialize() {
    if (this.initPromise) {
      return this.initPromise;
    } else {
      this.initPromise = this.backend.cachedChannelApi.validChannels(this.backend, false).then(channels => {
        this.allChannels = channels.allChannels;
        this.validChannels = channels.validChannels;
        this.initialized = true;
        // map data to new EpgGuideChannelDataSource
        this.channelDatasources = this.validChannels.map(el => new EpgGuideChannelDataSource(this.backend, el));

        // sort based on channelNumber
        function compare(a: EpgGuideChannelDataSource, b: EpgGuideChannelDataSource) {
          if (a.getChannelNumber() < b.getChannelNumber()) {
            return -1;
          }
          if (a.getChannelNumber() > b.getChannelNumber()) {
            return 1;
          }
          return 0;
        }

        this.channelDatasources.sort(compare);

        // put favorite channels first
        const favPromisses = this.channelDatasources.map(el => el.updateFavorite());
        return Promise.all(favPromisses).then(() => {
          const favs = this.channelDatasources.filter(el => el.isFavorite());
          const other = this.channelDatasources.filter(el => !el.isFavorite());
          this.channelDatasources = favs.concat(other);
        });
      });
    }

    return this.initPromise;
  }

  /**
   * load next channels
   */
  loadNext() {
    return this._initialize().then(() => {
      let amountToLoad = _constants.loadAmount;
      if (this.loadedIdx === 0) {
        amountToLoad = _constants.firstLoadAmount;
      }
      const result = this.channelDatasources.slice(this.loadedIdx, this.loadedIdx + amountToLoad);
      this.loadedIdx += amountToLoad;
      return result;
    });
  }

  hasNext(): boolean {
    if (!this.initialized) return true;
    return this.loadedIdx < this.channelDatasources.length;
  }

  logPageView(title: string) {
    this.backend.logService.trackPageView(StaticPageUrls.epgGuide, title);
  }
}
